var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.975,
    height: 35,
    viewBox: "0 0 33.975 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d86b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed9035"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349",
    transform: "translate(-342.295 -263.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_34",
    "data-name": "Subtraction 34",
    d: "M33.973,35H25.488l0,0L0,35l0,0,4.242-5.838,0,0L12.717,17.5,4.244,5.839l0,0L0,0,0,0H33.973l0,0L29.732,5.841l0,0L21.257,17.5,29.73,29.161l0,0L33.975,35l0,0ZM16.987,23.3,13.43,28.2l7.11,0L16.987,23.3ZM13.43,6.8l3.557,4.9L20.539,6.8l-7.109,0Z",
    transform: "translate(342.295 263.508)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 0.404,
    height: 14.649,
    transform: "translate(359.08 273.686)",
    fill: "#16161d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamsSmall);
export default __webpack_public_path__ + "static/media/exams_small.a5513b55ae0bc4b49f9aab7738d1ce89.svg";
export { ForwardRef as ReactComponent };